import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { showAnimation } from 'src/animations';
import { quillOptions } from '../../../globals';
import { IIssueTransactionView } from '../../../interfaces';
import { STEP_FORM_GROUP } from '../../dialog/issue-transaction-dialog2/issue-transaction-dialog2-component-classes';

@Component({
  selector: 'app-note-form',
  templateUrl: './note-form.component.html',
  styleUrls: ['./note-form.component.css'],
  animations: [ showAnimation ]
})
export class NoteFormComponent implements IIssueTransactionView, OnInit {

  placeholder: string = "Bearbeitungsnotiz verfassen"

  constructor(
    @Inject(STEP_FORM_GROUP) public formGroup: FormGroup
  ) { }

  ngOnInit(): void {
  }

  // controls
  get noteControl(): AbstractControl {
    return this.formGroup.controls['note'];
  }

  // quill
  public quillModules = quillOptions;

}
